import { safelyExecute } from './safelyExecute';

export const scrollElementIntoView = (targetSelector: string, options?: ScrollIntoViewOptions): void => {
	safelyExecute(() => {
		const scrollTarget = window.document.querySelector(targetSelector);
		if (scrollTarget) {
			(window.document.activeElement as undefined | HTMLElement)?.blur();
			scrollTarget.scrollIntoView(options);
		}
	});
};
